import styled from 'styled-components';

export const Container = styled.div`
	border: 1px solid #d9d9d9;
	border-radius: 0.25rem;
	width: 100%;
	margin-bottom: 1rem;
`;
